export const IRPortalEnv = {
  Dev: 'ir-portal-dev',
  Prod: 'ir-portal-prod',
};

export interface LoginRequest {
  envName: string;
}

export interface ImpersonateUserRequest {
  envName: string;
  username: string;
}

export interface VerifyTokenResponse {
  valid: boolean;
}

export interface LoginResponse {
  data: {
    envName: string;
    accessToken: string;
  };
}

export type ModuleFunction =
  | {
      moduleName: 'assume-identity';
      functionName: 'assume-user' | string;
    }
  | {
      moduleName: 'investor-management';
      functionName:
        | 'portal-access'
        | 'read-investor-profile'
        | 'decrypt-audit-values'
        | 'write-investor-profile'
        | 'read-investor-interactions'
        | 'write-investor-interactions'
        | 'read-contact-persons'
        | 'read-investor-activity-history'
        | 'read-data-masking-run-status'
        | string;
    };

export const Permission = {
  PortalAccess: {
    moduleName: 'investor-management',
    functionName: 'portal-access',
  },
} as const satisfies Record<string, ModuleFunction>;

export interface AuthPayload {
  env: string;
  roles: string[];
  exp: number;
  aud: string;
  iss: string;
  sub: string;
}

export interface User {
  name: string;
  roles: string[];
  env: string;
  exp: number;
  token: string;
}

export interface AuthState {
  user?: User;
  permissions?: ModuleFunction[];
  impersonatedUsername?: string;
}

export const Role = {
  Developer: 'ir-developer',
  InvestorRelations: 'investor-relations-team',
  Finance: 'finance',
};
export type Role = (typeof Role)[keyof typeof Role];
